import React, { useState } from "react";

import {
  Root,
  Container,
  Logo,
  MenuButton,
  MenuContainer,
  Link,
  ButtonLink,
} from "./Header.style";

import logoSrc from "../../assets/logo.png";

import { MobileMenu } from "../MobileMenu/MobileMenu";
import { ModalEntry } from "../ModalEntry/ModalEntry";

export const Header = () => {
  const [menuIsShow, setMenuIsShow] = useState(false);
  const [entryShow, setEntryShow] = useState(false);

  return (
    <Root>
      <Container>
        <Logo src={logoSrc} alt="Ole Smoky Moonshine logo" />
        <MenuButton type="button" onClick={() => setMenuIsShow(true)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width={48}
          >
            <path
              fill="currentColor"
              d="M42 24a1.503 1.503 0 0 1-1.5 1.5h-33A1.503 1.503 0 0 1 6 24a1.503 1.503 0 0 1 1.5-1.5h33A1.503 1.503 0 0 1 42 24ZM7.5 13.5h33A1.503 1.503 0 0 0 42 12a1.503 1.503 0 0 0-1.5-1.5h-33A1.503 1.503 0 0 0 6 12a1.503 1.503 0 0 0 1.5 1.5Zm33 21h-33A1.503 1.503 0 0 0 6 36a1.503 1.503 0 0 0 1.5 1.5h33A1.503 1.503 0 0 0 42 36a1.503 1.503 0 0 0-1.5-1.5Z"
            />
          </svg>
        </MenuButton>

        {menuIsShow && (
          <MobileMenu
            onClose={() => setMenuIsShow(false)}
            onEntryShow={() => setEntryShow(true)}
          />
        )}

        <MenuContainer>
          <Link to="home" duration={150} spy={true} activeClass="--active">
            Home
          </Link>
          <Link to="prizes" duration={150} spy={true} activeClass="--active">
            Prizes
          </Link>
          <Link to="cocktails" duration={150} spy={true} activeClass="--active">
            Cocktails
          </Link>
          <Link to="merch" duration={150} spy={true} activeClass="--active">
            Merch
          </Link>
          <ButtonLink type="button" onClick={() => setEntryShow(true)}>
            Enter for a chance to win
          </ButtonLink>
        </MenuContainer>
      </Container>

      {entryShow && <ModalEntry onClose={() => setEntryShow(false)} />}
    </Root>
  );
};
